import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";
import type { Page, Invoice, InvoiceQueryParams, InvoiceVo } from "@zhihaoscm/entity";

export class invoiceService extends BaseService<unknown, unknown, unknown, unknown> {
    public async paging(params: InvoiceQueryParams): Promise<Page<Invoice>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }
    //开票详情
    public async findById(id: string): Promise<InvoiceVo> {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }
    //已开票总金额
    public async totalCount(params: { productId?: string; productType?: number }): Promise<Invoice> {
        const { data } = await this.service.get(`${this.path}/calc-total-count`, { params });
        return data;
    }

    // 分页查询-app端
    public async customAppPaging(params: InvoiceQueryParams): Promise<Page<InvoiceVo>> {
        const { data } = await this.service.get(`${this.path}/custom-app-paging`, { params });
        return data;
    }
}
export const tradeInvoiceService = new invoiceService("/invoice", httpRequest);
